import React from "react";

export default function ComingSoon () {
    return (
        <div className="" align="center" >
            Fret not, this funtionality is coming soon!
        </div>
    )
}